var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetgearIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#netgear_icon_svg__clip0_3951_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.406 15.594V.38h4.126l6.95 9.343V.38h4.125v15.213h-4.125l-6.95-9.415v9.415H.406z",
    fill: "#6B0E89"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "netgear_icon_svg__clip0_3951_1524"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM5NTFfMTUyNCkiPgo8cGF0aCBkPSJNMC40MDYyNSAxNS41OTM2VjAuMzgwODU5SDQuNTMyMTRMMTEuNDgxNSA5LjcyMzYzVjAuMzgwODU5SDE1LjYwNzRWMTUuNTkzNkgxMS40ODE1TDQuNTMyMTQgNi4xNzkzNlYxNS41OTM2SDAuNDA2MjVaIiBmaWxsPSIjNkIwRTg5Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMzk1MV8xNTI0Ij4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgNetgearIcon as ReactComponent };